import styled from 'styled-components';

const TypeformStyles = styled.section`
  background-color: var(--color-${(props) => props?.bgColor});
  text-align: center;
  padding: ${(props) => (props?.bgColor === 'white' ? '0' : '3rem')};

  .heading,
  .text-wrapper {
    color: ${(props) =>
      props?.bgColor === 'charcoal'
        ? 'var(--color-white)'
        : 'var(--color-charcoal)'};
  }

  .text-wrapper {
    margin: 0 auto;
    max-width: 80rem;
  }

  .form {
    margin-top: 3rem;
    min-height: 35rem;
  }

  @media (min-width: 768px) {
    padding: ${(props) => (props?.bgColor === 'white' ? '0' : '5rem')};

    .form {
      min-height: 45rem;
    }
  }
`;

export default TypeformStyles;
